<template>
  <div class="d-flex">
    <base-loading v-if="loading" />
    <div v-else>
      <span v-if="form.value"> {{ form.value }} {{ field.prefix }} </span>
      <sup v-if="history">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" small class="mx-2" color="primary" v-on="on">
              mdi-history
            </v-icon>
          </template>
          <span
            >Esse campo foi alterado na data de
            {{ moment(new Date(history)).format('lll') }}</span
          >
        </v-tooltip>
      </sup>

      <v-dialog v-if="!draft" v-model="dialog" persistent max-width="290">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="relatorio.structure != 'old'"
            class="mx-2"
            icon
            fab
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-cog </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5"> Atualizar {{ title }} </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form.value"
              :label="field.label"
              :type="field.type"
              :rules="field.rules"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="cancel"> Cancelar </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="btnLoading"
              :disabled="btnLoading || !form.value"
              @click="update"
            >
              Atualizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import reportService from '../../services/api/reports'

export default {
  name: 'UpdateFields',

  props: {
    id: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },

    field: {
      type: Object,
      required: true,
    },

    draft: {
      type: Boolean,
      default: false,
    },

    relatorio: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      moment,
      dialog: false,

      form: {
        value: null,
      },

      loading: false,

      btnLoading: false,

      history: null,
    }
  },

  computed: {
    ...mapGetters('report', [
      'getValue',
      'getReportValue',
      'getAssocietedField',
      'recalculatedFields',
    ]),
  },

  mounted() {
    this.form.value = this.parsedNumber(this.getValue(this.field.property))

    this.index()
  },

  methods: {
    async index() {
      if (this.draft) return

      const reportItem = this.getReportValue(this.field.key)

      if (!reportItem?.history) return

      const history = reportItem.history?.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt)
      })[0]

      if (!history) return

      this.history = history.updatedAt
    },
    cancel() {
      this.dialog = false
      this.form.value = this.getValue(this.field.property)
    },
    async update() {
      this.btnLoading = true

      try {
        const fields = this.getAssocietedField(this.field.key)
        const fieldUpdate = fields.map(field => {
          const rule = field.rules.find(rule => rule.key == 'fieldCalculated')
          return {
            key: field.name,
            label: field.label,
            value: this.recalculatedFields(
              rule.value,
              this.field.key,
              this.form.value,
            ),
          }
        })

        fieldUpdate.unshift({
          key: this.field.key,
          label: this.field.label,
          value: this.form.value,
        })

        await reportService.updateFields({
          id: this.id,
          fields: fieldUpdate,
        })

        this.Toast().fire({
          icon: 'success',
          title: 'Campo atualizado com sucesso!',
        })

        this.dialog = false
        this.history = new Date()
        this.relatorio[this.field.property] = this.form.value
      } catch (error) {
        this.Toast().fire({
          icon: 'error',
          title: 'Erro ao atualizar campo!' + error,
        })
      } finally {
        this.btnLoading = false
      }
    },

    parsedNumber(value) {
      if (value.includes(',')) {
        return parseFloat(value.replace(',', '.'))
      }

      return value
    },
  },
}
</script>
